import { useEffect, useState } from "react"
import { InlineSVG } from "../../../../shared/components"
import { IMapLayer, MapLayerTypes } from "../../../../shared/models/map_models"

export interface IMapLayerIconProps {
    mapLayer: IMapLayer
    iconClicked?: () => void
}


const MapLayerIcon = (props: IMapLayerIconProps) => {

    const [icon, setIcon] = useState<string | null>(null)
    const [iconColor, setIconColor] = useState<string | null>(null) 

    useEffect(() => {

        setIcon(null)
        setIconColor(null)

        const mapConfigs = props.mapLayer.map_configs
        if(mapConfigs.type === MapLayerTypes.Point){
            if(!mapConfigs.icon_image)
                setIcon("/assets/default_map_marker.svg")
            setIconColor(mapConfigs.point_color || null)
        } else if (mapConfigs.type === MapLayerTypes.Cluster){
            setIcon('/assets/circle.svg')
            const clusterConfigs = mapConfigs.cluster_configs
            if (clusterConfigs && clusterConfigs.length > 0)
                setIconColor(clusterConfigs[0].color)
        }

    }, [props.mapLayer])

    return (
        <>
            {icon &&
                <InlineSVG
                    src={icon}
                    color={iconColor || undefined}
                    iconClicked={props.iconClicked}
                />
            }
        </>
    )
}


export default MapLayerIcon